import { CommerceCreatorLandingPage } from './CommerceCreatorLandingPage';

export const commerceCreatorLandingRouter = {
  '/@/commerce_creator': CommerceCreatorLandingPage,
};
